// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepBasic__dDYnC {
  display: flex;
  flex-direction: column;
  row-gap: 9px;
}

.stepMainDetailsInfo__LY5bj {
  display: flex;
  flex-direction: column;
  row-gap: 9px;
}

.stepVerify__LOxXM {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.relative__RFtvN {
  position: relative;
}

.infoIcon__dKvHG {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
.infoIcon__dKvHG circle {
  stroke: var(--buttons-surface);
}
.infoIcon__dKvHG path {
  fill: var(--buttons-surface);
}
.infoIcon__dKvHG:focus, .infoIcon__dKvHG:active {
  outline: none !important;
}

.helperText__OJswl {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-top: 4px;
  min-height: 11px;
}
@media (max-width: 850px) {
  .helperText__OJswl {
    font-size: 8px;
    line-height: 8px;
    margin-top: 2px;
    min-height: 8px;
  }
}

.fieldLabel__mSyjE {
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--inputs-disable-text);
  display: block;
  margin-bottom: 8px;
  padding-right: 17px;
}

.requiredLabel__gS_Hb::after {
  content: "*";
  font-size: 10px;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-left: 4px;
}

.mainDetails__s4wtm {
  display: grid;
  align-items: flex-end;
  grid-template-columns: 1fr 330px 16px;
  column-gap: 24px;
  margin-bottom: 5px;
}

.metricsInfoForm__sXZG9 {
  padding-bottom: 10px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}

.twoParts__Chzme {
  display: grid;
  align-items: flex-end;
  column-gap: 24px;
  grid-template-columns: 1fr 1fr;
  row-gap: 24px;
}

.threeParts___AspT {
  display: grid;
  align-items: flex-end;
  column-gap: 24px;
  grid-template-columns: 1fr 1fr 1fr;
}

.scrollingBlock__azehC {
  overflow-y: auto;
}
.scrollingBlock__azehC::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.scrollingBlock__azehC::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.scrollingBlock__azehC::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.scrollingBlock__azehC::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.totalCsBlock__tB_AK {
  margin-top: 10px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
}

.fieldValueDisabled__zRLXI {
  color: var(--inputs-disable-text);
  display: flex;
  align-items: center;
  column-gap: 5px;
  padding: 9px 12px;
  border-radius: 2px;
  background: var(--inputs-disable-disable-surface);
}

.fieldMark__m3EIX {
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.01em;
  color: var(--inputs-disable-text);
  white-space: nowrap;
  padding-right: 5px;
}

.addMoreBtnWrapper__XaQEQ {
  text-align: right;
}

.addMoreBtn__FfKYT {
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  line-height: 12px;
  color: var(--buttons-surface);
  text-transform: uppercase;
  text-decoration: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.addMoreBtnDisabled__y3O5E {
  pointer-events: none;
  opacity: 0.5;
}

.partsItem__rQywO {
  display: grid;
  align-items: flex-end;
  grid-template-columns: 1fr 1fr 1fr 16px;
  column-gap: 24px;
  padding-right: 35px;
  position: relative;
}

.removePartIcon__Tr9Wa {
  cursor: pointer;
  margin-bottom: 24px;
}

.attachFieldWrapper__eDdl7 {
  height: 100%;
}

.replacedParts__zsbC5 {
  margin-bottom: 10px;
}

.valuesItems__Uxxmo:not(:last-child) {
  margin-bottom: 10px;
}

.fieldWrapper__uq2f6 {
  position: relative;
}

.metricsInfoTooltip__oxH_D {
  max-width: 400px;
}

.relative__RFtvN {
  position: relative;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/CompletionReportModal/components/style.module.scss"],"names":[],"mappings":"AAgFA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA/EF;;AAkFA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA/EF;;AAkFA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AA/EF;;AAkFA;EACE,kBAAA;AA/EF;;AAkFA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;AA/EF;AAiFE;EACE,8BAAA;AA/EJ;AAkFE;EACE,4BAAA;AAhFJ;AAmFE;EAEE,wBAAA;AAlFJ;;AAsFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AAnFF;AAqFE;EARF;IASI,cAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;EAlFF;AACF;;AAqFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,iCAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAlFF;;AAqFA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,gBAAA;AAlFF;;AAqFA;EACE,aAAA;EACA,qBAAA;EACA,qCAAA;EACA,gBAAA;EACA,kBAAA;AAlFF;;AAqFA;EACE,oBAAA;EACA,yDAAA;AAlFF;;AAqFA;EA/FE,aAAA;EACA,qBAAA;EACA,gBAAA;EA+FA,8BAAA;EACA,aAAA;AAhFF;;AAmFA;EArGE,aAAA;EACA,qBAAA;EACA,gBAAA;EAqGA,kCAAA;AA9EF;;AAiFA;EACE,gBAAA;AA9EF;AA9EE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAgFJ;AA7EE;EACE,+BAAA;EACA,kBAAA;AA+EJ;AA5EE;EACE,8BAAA;EACA,kBAAA;AA8EJ;AA3EE;EACE,gBAAA;EACA,kBAAA;AA6EJ;;AAkEA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;AA/DF;;AAkEA;EACE,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iDAAA;AA/DF;;AAkEA;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iCAAA;EACA,mBAAA;EACA,kBAAA;AA/DF;;AAkEA;EACE,iBAAA;AA/DF;;AAkEA;EACE,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,qBAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;AA/DF;;AAkEA;EACE,oBAAA;EACA,YAAA;AA/DF;;AAkEA;EACE,aAAA;EACA,qBAAA;EACA,uCAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AA/DF;;AAkEA;EACE,eAAA;EACA,mBAAA;AA/DF;;AAkEA;EACE,YAAA;AA/DF;;AAkEA;EACE,mBAAA;AA/DF;;AAmEE;EACE,mBAAA;AAhEJ;;AAoEA;EACE,kBAAA;AAjEF;;AAoEA;EACE,gBAAA;AAjEF;;AAoEA;EACE,kBAAA;AAjEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n@mixin completionReportFields {\n  display: grid;\n  align-items: flex-end;\n  column-gap: 24px;\n}\n\n.stepBasic {\n  display: flex;\n  flex-direction: column;\n  row-gap: 9px;\n}\n\n.stepMainDetailsInfo {\n  display: flex;\n  flex-direction: column;\n  row-gap: 9px;\n}\n\n.stepVerify {\n  display: flex;\n  flex-direction: column;\n  row-gap: 24px;\n}\n\n.relative {\n  position: relative;\n}\n\n.infoIcon {\n  position: absolute;\n  top: 0;\n  right: 0;\n  cursor: pointer;\n\n  circle {\n    stroke: var(--buttons-surface);\n  }\n\n  path {\n    fill: var(--buttons-surface);\n  }\n\n  &:focus,\n  &:active {\n    outline: none !important;\n  }\n}\n\n.helperText {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--inputs-error-text-helper);\n  margin-top: 4px;\n  min-height: 11px;\n\n  @media (max-width: 850px) {\n    font-size: 8px;\n    line-height: 8px;\n    margin-top: 2px;\n    min-height: 8px;\n  }\n}\n\n.fieldLabel {\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  text-transform: uppercase;\n  color: var(--inputs-disable-text);\n  display: block;\n  margin-bottom: 8px;\n  padding-right: 17px;\n}\n\n.requiredLabel::after {\n  content: '*';\n  font-size: 10px;\n  line-height: 12px;\n  color: var(--inputs-error-text-helper);\n  margin-left: 4px;\n}\n\n.mainDetails {\n  display: grid;\n  align-items: flex-end;\n  grid-template-columns: 1fr 330px 16px;\n  column-gap: 24px;\n  margin-bottom: 5px;\n}\n\n.metricsInfoForm {\n  padding-bottom: 10px;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n}\n\n.twoParts {\n  @include completionReportFields;\n  grid-template-columns: 1fr 1fr;\n  row-gap: 24px;\n}\n\n.threeParts {\n  @include completionReportFields;\n  grid-template-columns: 1fr 1fr 1fr;\n}\n\n.scrollingBlock {\n  overflow-y: auto;\n\n  @include scrollBar;\n}\n\n.totalCsBlock {\n  margin-top: 10px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 24px;\n}\n\n.fieldValueDisabled {\n  color: var(--inputs-disable-text);\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n  padding: 9px 12px;\n  border-radius: 2px;\n  background: var(--inputs-disable-disable-surface);\n}\n\n.fieldMark {\n  font-size: 12px;\n  line-height: 20px;\n  letter-spacing: 0.01em;\n  color: var(--inputs-disable-text);\n  white-space: nowrap;\n  padding-right: 5px;\n}\n\n.addMoreBtnWrapper {\n  text-align: right;\n}\n\n.addMoreBtn {\n  font-family: 'Roboto', sans-serif;\n  font-size: 12px;\n  line-height: 12px;\n  color: var(--buttons-surface);\n  text-transform: uppercase;\n  text-decoration: none;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n.addMoreBtnDisabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.partsItem {\n  display: grid;\n  align-items: flex-end;\n  grid-template-columns: 1fr 1fr 1fr 16px;\n  column-gap: 24px;\n  padding-right: 35px;\n  position: relative;\n}\n\n.removePartIcon {\n  cursor: pointer;\n  margin-bottom: 24px;\n}\n\n.attachFieldWrapper {\n  height: 100%;\n}\n\n.replacedParts {\n  margin-bottom: 10px;\n}\n\n.valuesItems {\n  &:not(:last-child) {\n    margin-bottom: 10px;\n  }\n}\n\n.fieldWrapper {\n  position: relative;\n}\n\n.metricsInfoTooltip {\n  max-width: 400px;\n}\n\n.relative {\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepBasic": `stepBasic__dDYnC`,
	"stepMainDetailsInfo": `stepMainDetailsInfo__LY5bj`,
	"stepVerify": `stepVerify__LOxXM`,
	"relative": `relative__RFtvN`,
	"infoIcon": `infoIcon__dKvHG`,
	"helperText": `helperText__OJswl`,
	"fieldLabel": `fieldLabel__mSyjE`,
	"requiredLabel": `requiredLabel__gS_Hb`,
	"mainDetails": `mainDetails__s4wtm`,
	"metricsInfoForm": `metricsInfoForm__sXZG9`,
	"twoParts": `twoParts__Chzme`,
	"threeParts": `threeParts___AspT`,
	"scrollingBlock": `scrollingBlock__azehC`,
	"totalCsBlock": `totalCsBlock__tB_AK`,
	"fieldValueDisabled": `fieldValueDisabled__zRLXI`,
	"fieldMark": `fieldMark__m3EIX`,
	"addMoreBtnWrapper": `addMoreBtnWrapper__XaQEQ`,
	"addMoreBtn": `addMoreBtn__FfKYT`,
	"addMoreBtnDisabled": `addMoreBtnDisabled__y3O5E`,
	"partsItem": `partsItem__rQywO`,
	"removePartIcon": `removePartIcon__Tr9Wa`,
	"attachFieldWrapper": `attachFieldWrapper__eDdl7`,
	"replacedParts": `replacedParts__zsbC5`,
	"valuesItems": `valuesItems__Uxxmo`,
	"fieldWrapper": `fieldWrapper__uq2f6`,
	"metricsInfoTooltip": `metricsInfoTooltip__oxH_D`
};
module.exports = ___CSS_LOADER_EXPORT___;
